<script setup>
import { inject, computed } from 'vue';
import SchoolPage from '@/components/result/ai-literacy/SchoolPage.vue';

// 부모 컴포넌트에서 전달받은 데이터
const principalData = inject('principalData');

</script>


<template>
  <div class="report-inner">
    <SchoolPage
            reportType="principal"
            :reportData="principalData"
        />
  </div>
</template>

<style lang="scss" scoped>

</style>